import './signin.styles.scss'

const SignIn = () => {
    return(
        <>
            <h1>Sign in</h1>
            <h2>For now there is no need for an account!</h2>
        </>
    )
}

export default SignIn